export default __webpack_public_path__ + "static/media/medDefault.56ce146d.svg";